import React, {useRef, useState, useEffect, useCallback} from 'react';
import Header from '../../components/Header';
import { GlobalStyle } from '../../styles/global';
import { useAuth } from '../../hooks/Auth';
import { Main, Thumb } from './styles';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import Input from '../../components/Elements/Input';
import Button from '../../components/Elements/Button';
import Switch from "react-switch";
import {api} from '../../services/api';
import Loading from '../../components/Loading';
import toast from 'react-hot-toast';
import getValidationErros from '../../utils/getValidationErros';
import * as Yup from 'yup';

interface PessoalFormData{  
    nome: string;
    email: string;
    oldpass: string;
    pass: string;
    repass: string;
    desejogravidez: boolean;    
}

interface AcessosFormData{
    nomeconjuge?: string,
    emailconjuge?: string,
    emailinstrutor?: string
}


const Perfil: React.FC = () => {
    const { user, updateUser } = useAuth();

    const formRef = useRef<FormHandles>(null);
    const form2Ref = useRef<FormHandles>(null);

    const [load, setLoad] = useState(true);
    const [desejo, setDesejo] = useState(false);
    const [editconj, setEditconj] = useState(false);
    const [editintru, setEditintru] = useState(false);
    const [nomeconj, setNomeconj] = useState('');
    const [emailconj, setEmailconj] = useState('');
    const [emailintru, setEmailinstru] = useState('');


    const getInfoPerfil = useCallback(async () => {
    
        const params = { id_user : user.iduser }
        await api.get('/users/getInfo.php', { params : params })
        .then((resp: any) => {
            
            setDesejo(resp.data[0].desejogravidez === 'on' ? true : false); 
            setEditconj(resp.data[0].editconjuge === 'on' ? true : false);
            setEditintru(resp.data[0].editinstrutor === 'on' ? true : false); 
            setNomeconj(resp.data[0].nomeconjuge);    
            setEmailconj(resp.data[0].emailconjuge);    
            setEmailinstru(resp.data[0].emailinstrutor)

            
        }
        );        
    }, [user.iduser]);

    useEffect(() => {
        try {
            getInfoPerfil();
        } catch (err) {
            // console.log(err);
        } finally {
            setLoad(false);
        }
    }, [getInfoPerfil]);

    async function handleChangeDados(data: PessoalFormData){

        if(data.pass === data.repass){
            try {
                formRef.current?.setErrors({});
                const schema = Yup.object().shape({
                    nome: Yup.string().required('Nome obrigatório').min(5, 'Mínimo 5 caracteres').max(70, 'Máximo de 70 caracteres'),
                    email: Yup.string().required('Email obrigatório').email('Insira um email válido').min(5, 'Mínimo 5 caracteres'),
                    oldpass: Yup.string(),
                    pass: Yup.string().when('oldpass', {
                        is: (value : string ) => value.length > 0,
                        then: Yup.string().required('Campo Obrigatório'),
                        otherwise: Yup.string(),
                    }),
                    repass: Yup.string().when('oldpass', {
                        is: (value : string ) => value.length > 0,
                        then: Yup.string().required('Campo Obrigatório'),
                        otherwise: Yup.string(),
                    }).oneOf([Yup.ref('pass'), null], 'Confirmação incorreta'),
                });
                await schema.validate(data, { abortEarly: false, });
    
                const send = Object.assign({
                    "id_user": user.iduser,
                    "nome": data.nome,
                    "email": data.email,
                    "desejogravidez": desejo ? 'on' : 'off',  
                }, data.oldpass ? {
                    "oldpass" : data.oldpass ? data.oldpass : null,
                    "pass": data.pass ? data.pass : null
                } : {});

                // console.log(send);
            
                await api.post('/users/updateUsers.php', send);
                
                updateUser({                    
                    "email": data.email,
                    "iduser": user.iduser,
                    "nome": data.nome,
                    "jwt": user.jwt,
                    "assinante": user.assinante,
                    "thumb_user": user.thumb_user,
                    "vitalicio": user.vitalicio,
                })
                toast.success('ATUALIZAÇÃO REALIZADA COM SUCESSO');               
                    
            } catch (err: any) {
              if(err instanceof Yup.ValidationError){
                const errors = getValidationErros(err);
                formRef.current?.setErrors(errors);
                return;
              }
              
              const resp = err.response.statusText ? err.response.statusText : 'ERRO AO TENTAR ATUALIZAR';
              toast.error(resp);
            }
          } else {
            toast.error('ERRO, AS NOVAS SENHAS NÃO SÃO IGUAIS');
          }

    }

    async function handleChangeAcessos(data: AcessosFormData){
        try {
            
            form2Ref.current?.setErrors({});
            const schema = Yup.object().shape({
                nomeconjuge: Yup.string(),
                emailconjuge: Yup.string().email('Insira um email válido'),
                emailinstrutor: Yup.string().email('Insira um email válido')
                
            });
            await schema.validate(data, { abortEarly: false, });

            
            const send = {
                "id_user": user.iduser,
                "nomeconjuge": data.nomeconjuge,
                "emailconjuge": data.emailconjuge,
                "editconjuge": editconj ? 'on' : 'off',
                "emailinstrutor": data.emailinstrutor,
                "editinstrutor": editintru ? 'on' : 'off',
            }
            // console.log(send);
        
            await api.post('/users/updateAcessos.php', send);               
            toast.success('ATUALIZAÇÃO REALIZADA COM SUCESSO');  

        } catch (err: any) {
            if(err instanceof Yup.ValidationError){
                const errors = getValidationErros(err);
                form2Ref.current?.setErrors(errors);
                return;
              }
            const resp = err.response.statusText ? err.response.statusText : 'ERRO AO TENTAR ATUALIZAR';
            toast.error(resp);
        }
        //window.location.reload();
    };
                

    return (
    <>

        <Header />
        {!load ? (
        <Main>        
            <h1>Editar Perfil</h1>
            <div className="wform">
                {user.thumb_user && <Thumb><img src={user.thumb_user} alt={user.nome} /></Thumb>}
                
                <h2>Dados Pessoais</h2>
                <Form ref={formRef} initialData={{
                    nome: user.nome,
                    email: user.email
                }} onSubmit={handleChangeDados}>
                    <Input type="text" name="nome" placeholder="SEU NOME" />
                    <Input type="text" name="email" placeholder="SEU EMAIL" /> 

                    <div className="flex">
                        <label>DESEJA ENGRAVIDAR? </label>
                        <div className="flex">
                        <strong>{desejo ? 'SIM' : 'NÃO'}</strong>
                        <Switch onChange={() => setDesejo(!desejo)} checked={desejo} activeBoxShadow="0 0 5px #E4DDCC" onColor="#FF50A7" offColor="#D5D2C9" />
                        </div>
                    </div>
                    <br /><h2>TROCAR SENHA</h2>
                    <Input type="password" name='oldpass' placeholder="SENHA ATUAL" />
                    <Input type="password" name='pass' placeholder="NOVA SENHA" />
                    <Input type="password" name='repass' placeholder="NOVA SENHA NOVAMENTE" />
                    <Button type="submit">atualizar</Button>
                </Form>

                <hr />

                <h2>Pessoas com acesso ao seu gráfico:</h2>
                <p>
                <br />
                Digite abaixo o email das pessoas que podem ter acesso a sua conta, bem como a possibilidade de edição do seu painel por parte desta pessoa.
                <br /><br /> 
                Não utilize o método billings sem acompanhamento de um instrutor certificado, caso não tenha um <a href="https://www.cenplafam.com.br/" target="_blank" rel="noreferrer">clique aqui</a>.
                </p>
                <br />
                
                <Form ref={form2Ref} initialData={{
                    nomeconjuge: nomeconj,
                    emailconjuge: emailconj,
                    emailinstrutor: emailintru
                }} onSubmit={handleChangeAcessos}>
                    <h2>CÔNJUGE:</h2>
                    <Input type="text" name='nomeconjuge' placeholder="NOME DO SEU CÔNJUGE" />
                    <Input type="text" name='emailconjuge' placeholder="EMAIL DO SEU CÔNJUGE" />
                    <div className="flex">
                        <label>SEU CÔNJUGE PODERÁ EDITAR SEU PAINEL ?</label>
                        <div className="flex">
                        <strong>{editconj ? 'SIM' : 'NÃO'}</strong>
                        <Switch onChange={() => setEditconj(!editconj)} checked={editconj} activeBoxShadow="0 0 5px #E4DDCC" onColor="#FF50A7" offColor="#D5D2C9" />
                        </div>
                    </div>
                    <br />
                    <h2>INSTRUTOR(a):</h2>
                    <Input type="text" name='emailinstrutor' placeholder="EMAIL DO SEU INSTRUTOR DO MOB" />
                    <div className="flex">
                        <label>SEU INSTRUTOR PODERÁ EDITAR SEU PAINEL ?</label>
                        <div className="flex">
                        <strong>{editintru ? 'SIM' : 'NÃO'}</strong>
                        <Switch onChange={() => setEditintru(!editintru)} checked={editintru} activeBoxShadow="0 0 5px #E4DDCC" onColor="#FF50A7" offColor="#D5D2C9" />
                        </div>
                    </div>

                    <Button type="submit">atualizar</Button>
                </Form>
            </div>
        </Main>
        ) : (
            <Loading />
        )}
        <GlobalStyle />
    </>
    );
}

export default Perfil;